export default class ModalConfig {
  constructor(type, data, size, closeFunction, centered) {
    this.type = type;
    this.data = data;
    this.size = size;
    this.closeFunction = closeFunction;
    this.centered = centered == undefined ? true : centered;
  }
}